import images from '@assets/images/index'
import { useState } from 'react'

import { Link, useNavigate } from '@suntex.core/nav'
import { useAuth } from '@suntex.fim/auth/react'
import { EntityLevel } from '@suntex.fim/enums'

import {
  handleEnterOrSpacePress,
  handleKeyboardClick
} from '../../pages/app/LearningCenter/util'
import Login from '../Login'
import { BubbleModal, Button } from '../ui'

const navLinks = [
  {
    path: '/about-fim',
    label: 'About',
    aria: 'About First In Math'
  },
  {
    path: '/program-content',
    label: 'Content',
    aria: 'Program First In Math'
  },
  {
    path: '/proven-results',
    label: 'Results',
    aria: 'Result First In Math'
  },
  {
    path: '/news',
    label: 'News',
    aria: 'News First In Math'
  }
]
const renderNavLinks = () => {
  return navLinks.map(({ path, label, aria }) => (
    <li key={path}>
      <Link
        to={path}
        role="menuitem"
        tabIndex={0}
        aria-label={aria}
        onKeyDown={(e) => {
          handleKeyboardClick(e)
        }}
      >
        {label}
      </Link>
    </li>
  ))
}

function Nav() {
  const { isAuthenticated, login } = useAuth()
  const navigate = useNavigate()
  const [isOpen, setIsOpen] = useState(false)
  const [isLoginOpen, setIsLoginOpen] = useState(false)

  const navigateBasedOnEntityLevel = (
    entityLevel: number,
    entityId: number,
    schoolId?: number
  ) => {
    if (entityLevel === EntityLevel.Team) {
      // Team level
      navigate(`/team/${entityId}/dashboard`)
    } else if (entityLevel === EntityLevel.School) {
      // School level
      navigate(`/school/${schoolId ?? entityId}/dashboard`)
    } else if (entityLevel === EntityLevel.Player) {
      // Player level (id comes from the login, not the path)
      navigate('/player/dashboard')
    } else {
      // Default fallback for unknown entity levels
      navigate(`/`)
    }
  }

  const handleDashboardNavigation = () => {
    if (login?.entityId) {
      navigateBasedOnEntityLevel(
        login.entityLevel,
        login.entityId,
        login.schoolId
      )
    } else {
      // Fallback to current login info
      if (login?.entityId) {
        navigateBasedOnEntityLevel(
          login.entityLevel,
          login.entityId,
          login.schoolId
        )
      }
    }
  }
  if (isLoginOpen) {
    return (
      <BubbleModal
        handleClose={() => setIsLoginOpen(false)}
        isOpen={isLoginOpen}
      >
        <Login />
      </BubbleModal>
    )
  }
  return (
    <div className="nav">
      <Link to="/" className="nav__logo" aria-label="First In Math Home">
        <img src={images.Logo} alt="logo" />
      </Link>
      <ul className="nav__list">
        {renderNavLinks()}
        <li>
          {isAuthenticated ? (
            <Button
              shape="round"
              intent="secondary"
              onClick={handleDashboardNavigation}
            >
              Dashboard
            </Button>
          ) : (
            <Button
              shape="round"
              intent="secondary"
              onClick={() => setIsOpen(true)}
              aria-label="Open login modal"
              aria-expanded={isOpen}
              tabIndex={0}
            >
              Log in
            </Button>
          )}
          <BubbleModal
            handleClose={() => setIsOpen(false)}
            isOpen={isOpen}
            aria-label="Login form"
          >
            <Login />
          </BubbleModal>
        </li>
      </ul>
      <div className="nav__button">
        <Button
          shape="round"
          intent="icon"
          onClick={() => setIsOpen(true)}
          className="menu-icon"
          aria-label="Toggle mobile menu"
          aria-expanded={isOpen}
          aria-controls="mobile-menu"
          tabIndex={0}
        >
          <images.MenuIcon aria-hidden="true" focusable="false" />
        </Button>
        <BubbleModal handleClose={() => setIsOpen(false)} isOpen={isOpen}>
          <ul className="nav__mobile-list" id="mobile-menu" role="menu">
            <li>
              <Button
                shape="round"
                intent="primary"
                onClick={() => {
                  setIsLoginOpen(true)
                  setIsOpen(false)
                }}
                aria-label="Open login modal"
                tabIndex={0}
                onKeyDown={(e) =>
                  handleEnterOrSpacePress(e, () => {
                    setIsLoginOpen(true)
                    setIsOpen(false)
                  })
                }
              >
                Login
              </Button>
            </li>

            {renderNavLinks()}
          </ul>
        </BubbleModal>
      </div>
    </div>
  )
}

export default Nav
